import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { VerticalListing, Link, MaskedLink } from '@hz-design-system/web-ui';
import { formatImageUrl, ImageSize } from '@ecg-marktplaats/media-util-js-lib';

import formatPrice from '../utils/formatPrice';
import { trackGAEvent } from '../../../../utils/gaTracking';

import { TFeedItem } from 'types/TFeeds';

type TFeedItemProps = {
  item: TFeedItem;
};

const FeedItem = ({ item }: TFeedItemProps) => {
  const { t } = useI18nContext();

  const handleClick = () => {
    trackGAEvent('Click', 'CarsRecommender');
  };

  const LinkComponent = item.thinContent ? MaskedLink : Link;

  return (
    <LinkComponent href={item.url} onClick={handleClick} kind="block">
      <VerticalListing
        title={item.title}
        price={formatPrice(item.price, t)}
        imageSrc={formatImageUrl(item.picture?.url, ImageSize.Large, item.picture?.sizes)}
        imageLoading="lazy"
        decoding="async"
        imageOverlayLabel={item.isHomepageAdLabel ? t('feed.item.traits.homepage_ad') : ''}
      />
    </LinkComponent>
  );
};

export default React.memo(FeedItem);
